module.exports = __webpack_public_path__ + "static/media/ms.ad290547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ms.jpg
// module id = 42
// module chunks = 0